import React, { useState } from "react";
import { TextField, Button, Box } from "@mui/material";

function NonContactTachometer() {
  const [inputValue, setInputValue] = useState("");
  const [uncertainty, setUncertainty] = useState("");

  const handleChange = (e) => {
    const val = e.target.value;
    setInputValue(val);

    const value = parseFloat(val);
    if (!val) {
      setUncertainty("");
      return;
    }

    if (isNaN(value)) {
      setUncertainty("Invalid input");
      return;
    }

    if (value >= 6 && value < 60) {
        const calculated = 0.000053 * value;
        // Limit to 2 decimals
        setUncertainty(`${calculated.toFixed(5)}`);
    } else if (value >= 60 && value < 600) {
        const calculated = 0.0000075 * value;
        // Limit to 2 decimals
        setUncertainty(`${calculated.toFixed(5)}`);
    } else if (value >= 600 && value <= 99999) {
        const calculated = 0.000003 * value;
        // Limit to 2 decimals
        setUncertainty(`${calculated.toFixed(5)}`);
    } else {
      setUncertainty("Out of range");
    }
  };

  const handleCopy = () => {
    if (uncertainty && uncertainty !== "Out of range" && uncertainty !== "Invalid input") {
      navigator.clipboard.writeText(uncertainty);
    }
  };

  return (
    <Box
      sx={{
        maxWidth: 400,
        margin: "auto",
        mt: 5,
        p: 3,
        boxShadow: 3,
        borderRadius: 2,
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <TextField
        label="Enter Value (rpm))"
        variant="outlined"
        type="number"
        value={inputValue}
        onChange={handleChange}
        fullWidth
      />
      <TextField
        label="Uncertainty (rpm)"
        variant="outlined"
        value={uncertainty}
        InputProps={{
          readOnly: true,
        }}
        fullWidth
      />
      <Button
        variant="contained"
        onClick={handleCopy}
        disabled={!uncertainty || uncertainty === "Out of range" || uncertainty === "Invalid input"}
      >
        Copy
      </Button>
    </Box>
  );
}

export default NonContactTachometer;
